import { PasswordInput } from "@/frontend/shared/ui/PasswordInput";
import { BaseInput, TInputProps } from "./BaseInput";

export function Input({ type, ...rest }: TInputProps) {
  if (type === "password") return <PasswordInput {...rest} />;
  return <BaseInput type={type} {...rest} />;
}
